<template>
  <div
    v-on-clickaway="hideDropdown"
    :class="classes"
  >
    <!-- FIELD -->
    <div
      class="datepicker__field-wrapper"
      @click="toggleDropdownVisibility"
    >
      <label
        v-if="label"
        class="datepicker__label"
        :class="{'datepicker__label-top': date}"
      >
        {{ label }}
        <span v-if="required" class="datepicker__label-required">*</span>
      </label>
      <div class="datepicker__field">
        <div class="datepicker__text">
          <span class="datepicker__time">{{ time }} {{ time.length ? ',' : '' }}</span>
          <span class="datepicker__date">{{ formatDate(date) }}</span>
        </div>
        <CalendarArrow class="datepicker__arrow" />
      </div>
    </div>
    <!-- FIELD -->

    <!-- DROPDOWN -->
    <Transition name="slide-from-top-short">
      <div
        v-if="isDropdownVisible"
        class="datepicker__dropdown"
      >
        <!-- CALENDAR -->
        <Transition :name="dropdownInsideTransitionName" mode="out-in">
          <div
            v-if="!isPickingTime"
            key="date-picker"
            class="datepicker__dropdown-date"
          >
            <Datepicker
              :value="date"
              v-bind="datepickerOptions"
              @input="onDateChange"
            />
            <!-- <div class="datepicker__dropdown-button-container">
              <BaseButton
                class="datepicker__dropdown-button"
                type="secondary"
                @click="onPickTime"
              >
                {{ buttonsText.pickTime }}
              </BaseButton>
            </div> -->
          </div>
          <!-- CALENDAR -->

          <!-- TIME -->
          <div
            v-else
            key="time-picker"
            class="datepicker__dropdown-time"
          >
            <div class="datepicker__dropdown-time-title">{{ formatDate(date) }}</div>
            <div class="datepicker__dropdown-times">
              <div
                v-for="(timeItem, index) in getAvailableTimes(date)"
                :key="`time-item-${index}`"
                :class="[
                  'datepicker__dropdown-time-item',
                  { 'datepicker__dropdown-time-item_disabled': timeItem.disabled },
                  { 'datepicker__dropdown-time-item_selected': isTimeSelected(timeItem) }
                ]"
                @click="selectTime(timeItem)"
              >
                {{ timeItem.value }}
              </div>
            </div>
            <div class="datepicker__dropdown-button-container">
              <div
                class="datepicker__dropdown-back-to-calendar-button"
                @click="hideDropdown()"
              >
                <IconArrow class="datepicker__dropdown-back-to-calendar-button-arrow" />
                <div class="datepicker__dropdown-back-to-calendar-button-text">{{ buttonsText.backToCalendar }}</div>
              </div>
            </div>
            <!-- <div class="datepicker__dropdown-button-container">
              <BaseButton
                class="datepicker__dropdown-button"
                type="secondary"
                @click="hideDropdown"
              >
                {{ buttonsText.submit }}
              </BaseButton>
            </div> -->
          </div>
          <!-- TIME -->
        </Transition>
      </div>
    </Transition>
    <!-- DROPDOWN -->

    <!-- <Transition name="slide-from-top"> -->
    <span
      v-if="error && errorMsg"
      class="datepicker__error-msg"
    >
      {{ errorMsg }}
    </span>
    <ErrorIcon
      v-if="error && errorMsg"
      class="datepicker__error-msg-icon"
    />
    <!-- </Transition> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { format, getDay, differenceInMinutes } from 'date-fns'
  import { uk, enUS } from 'date-fns/locale'
  import { uk as datapickerUk, ro as datapickerRo, ru as datapickerRu, en as datapickerEn } from 'vuejs-datepicker/dist/locale'
  import Datepicker from 'vuejs-datepicker'
  import { mixin as clickaway } from 'vue-clickaway'
  import { cloneDeep, get } from 'lodash'
  import IconArrow from '@/assets/img/icons/arrow-long-left.svg?inline'
  import CalendarArrow from '@/assets/img/icons/calendar.svg?inline'
  import ErrorIcon from '@/assets/img/icons/error.svg?inline'
  import * as ru from 'date-fns/locale/ru/index.js'
  import * as ro from 'date-fns/locale/ro/index.js'

  export default {
    name: 'BaseDatePicker',
    components: {
      Datepicker,
      IconArrow,
      CalendarArrow,
      ErrorIcon
    },
    mixins: [ clickaway ],
    props: {
      globalTime: String,
      changeTime: Function,
      requestServiceIn: Number,
      workPeriod: [Function, Object],
      label: {
        type: String,
        default: ''
      },
      errorMsg: {
        type: String,
        default: ''
      },
      required: {
        type: Boolean,
        default: false
      },
      buttonsText: {
        type: Object,
        required: true,
        validator (buttonsText) {
          return 'pickTime' in buttonsText &&
            'submit' in buttonsText &&
            'backToCalendar' in buttonsText
        }
      },
      options: {
        type: [Object],
        required: true,
        default: () => ({})
        // validator (options) {
        //   return 'schedule' in options &&
        //     'enabled' in options.schedule
        // }
      }
    },

    data () {
      return {
        date: null,
        time: '',
        datesWithNoAvailableTime: [],
        isDropdownVisible: false,
        isPickingTime: false,
        error: null,
        datapickerLang: datapickerUk,
        timepickerLang: uk,
        'testworkPeriod': {
          'enabled': [
            [
              {
                'value': '09:00'
              },
              {
                'value': '09:15'
              },
              {
                'value': '09:30'
              },
              {
                'value': '09:45'
              },
              {
                'value': '10:00'
              },
              {
                'value': '10:15'
              },
              {
                'value': '10:30'
              },
              {
                'value': '10:45'
              },
              {
                'value': '11:00'
              },
              {
                'value': '11:15'
              },
              {
                'value': '11:30'
              },
              {
                'value': '11:45'
              },
              {
                'value': '12:00'
              },
              {
                'value': '12:15'
              },
              {
                'value': '12:30'
              },
              {
                'value': '12:45'
              },
              {
                'value': '13:00'
              },
              {
                'value': '13:15'
              },
              {
                'value': '13:30'
              },
              {
                'value': '13:45'
              },
              {
                'value': '14:00'
              },
              {
                'value': '14:15'
              },
              {
                'value': '14:30'
              },
              {
                'value': '14:45'
              },
              {
                'value': '15:00'
              },
              {
                'value': '15:15'
              },
              {
                'value': '15:30'
              },
              {
                'value': '15:45'
              },
              {
                'value': '16:00'
              },
              {
                'value': '16:15'
              },
              {
                'value': '16:30'
              },
              {
                'value': '16:45'
              },
              {
                'value': '17:00'
              }
            ],
            [
              {
                'value': '09:00'
              },
              {
                'value': '09:15'
              },
              {
                'value': '09:30'
              },
              {
                'value': '09:45'
              },
              {
                'value': '10:00'
              },
              {
                'value': '10:15'
              },
              {
                'value': '10:30'
              },
              {
                'value': '10:45'
              },
              {
                'value': '11:00'
              },
              {
                'value': '11:15'
              },
              {
                'value': '11:30'
              },
              {
                'value': '11:45'
              },
              {
                'value': '12:00'
              },
              {
                'value': '12:15'
              },
              {
                'value': '12:30'
              },
              {
                'value': '12:45'
              },
              {
                'value': '13:00'
              },
              {
                'value': '13:15'
              },
              {
                'value': '13:30'
              },
              {
                'value': '13:45'
              },
              {
                'value': '14:00'
              },
              {
                'value': '14:15'
              },
              {
                'value': '14:30'
              },
              {
                'value': '14:45'
              },
              {
                'value': '15:00'
              },
              {
                'value': '15:15'
              },
              {
                'value': '15:30'
              },
              {
                'value': '15:45'
              },
              {
                'value': '16:00'
              },
              {
                'value': '16:15'
              },
              {
                'value': '16:30'
              },
              {
                'value': '16:45'
              },
              {
                'value': '17:00'
              }
            ],
            [
              {
                'value': '09:00'
              },
              {
                'value': '09:15'
              },
              {
                'value': '09:30'
              },
              {
                'value': '09:45'
              },
              {
                'value': '10:00'
              },
              {
                'value': '10:15'
              },
              {
                'value': '10:30'
              },
              {
                'value': '10:45'
              },
              {
                'value': '11:00'
              },
              {
                'value': '11:15'
              },
              {
                'value': '11:30'
              },
              {
                'value': '11:45'
              },
              {
                'value': '12:00'
              },
              {
                'value': '12:15'
              },
              {
                'value': '12:30'
              },
              {
                'value': '12:45'
              },
              {
                'value': '13:00'
              },
              {
                'value': '13:15'
              },
              {
                'value': '13:30'
              },
              {
                'value': '13:45'
              },
              {
                'value': '14:00'
              },
              {
                'value': '14:15'
              },
              {
                'value': '14:30'
              },
              {
                'value': '14:45'
              },
              {
                'value': '15:00'
              },
              {
                'value': '15:15'
              },
              {
                'value': '15:30'
              },
              {
                'value': '15:45'
              },
              {
                'value': '16:00'
              },
              {
                'value': '16:15'
              },
              {
                'value': '16:30'
              },
              {
                'value': '16:45'
              },
              {
                'value': '17:00'
              }
            ],
            [
              {
                'value': '09:00'
              },
              {
                'value': '09:15'
              },
              {
                'value': '09:30'
              },
              {
                'value': '09:45'
              },
              {
                'value': '10:00'
              },
              {
                'value': '10:15'
              },
              {
                'value': '10:30'
              },
              {
                'value': '10:45'
              },
              {
                'value': '11:00'
              },
              {
                'value': '11:15'
              },
              {
                'value': '11:30'
              },
              {
                'value': '11:45'
              },
              {
                'value': '12:00'
              },
              {
                'value': '12:15'
              },
              {
                'value': '12:30'
              },
              {
                'value': '12:45'
              },
              {
                'value': '13:00'
              },
              {
                'value': '13:15'
              },
              {
                'value': '13:30'
              },
              {
                'value': '13:45'
              },
              {
                'value': '14:00'
              },
              {
                'value': '14:15'
              },
              {
                'value': '14:30'
              },
              {
                'value': '14:45'
              },
              {
                'value': '15:00'
              },
              {
                'value': '15:15'
              },
              {
                'value': '15:30'
              },
              {
                'value': '15:45'
              },
              {
                'value': '16:00'
              },
              {
                'value': '16:15'
              },
              {
                'value': '16:30'
              },
              {
                'value': '16:45'
              },
              {
                'value': '17:00'
              }
            ],
            [
              {
                'value': '09:00'
              },
              {
                'value': '09:15'
              },
              {
                'value': '09:30'
              },
              {
                'value': '09:45'
              },
              {
                'value': '10:00'
              },
              {
                'value': '10:15'
              },
              {
                'value': '10:30'
              },
              {
                'value': '10:45'
              },
              {
                'value': '11:00'
              },
              {
                'value': '11:15'
              },
              {
                'value': '11:30'
              },
              {
                'value': '11:45'
              },
              {
                'value': '12:00'
              },
              {
                'value': '12:15'
              },
              {
                'value': '12:30'
              },
              {
                'value': '12:45'
              },
              {
                'value': '13:00'
              },
              {
                'value': '13:15'
              },
              {
                'value': '13:30'
              },
              {
                'value': '13:45'
              },
              {
                'value': '14:00'
              },
              {
                'value': '14:15'
              },
              {
                'value': '14:30'
              },
              {
                'value': '14:45'
              },
              {
                'value': '15:00'
              },
              {
                'value': '15:15'
              },
              {
                'value': '15:30'
              },
              {
                'value': '15:45'
              },
              {
                'value': '16:00'
              },
              {
                'value': '16:15'
              },
              {
                'value': '16:30'
              },
              {
                'value': '16:45'
              },
              {
                'value': '17:00'
              }
            ],
            [
              {
                'value': '08:00'
              },
              {
                'value': '08:15'
              },
              {
                'value': '08:30'
              },
              {
                'value': '08:45'
              },
              {
                'value': '09:00'
              },
              {
                'value': '09:15'
              },
              {
                'value': '09:30'
              },
              {
                'value': '09:45'
              },
              {
                'value': '10:00'
              },
              {
                'value': '10:15'
              },
              {
                'value': '10:30'
              },
              {
                'value': '10:45'
              },
              {
                'value': '11:00'
              },
              {
                'value': '11:15'
              },
              {
                'value': '11:30'
              },
              {
                'value': '11:45'
              },
              {
                'value': '12:00'
              },
              {
                'value': '12:15'
              },
              {
                'value': '12:30'
              },
              {
                'value': '12:45'
              },
              {
                'value': '13:00'
              },
              {
                'value': '13:15'
              },
              {
                'value': '13:30'
              },
              {
                'value': '13:45'
              },
              {
                'value': '14:00'
              },
              {
                'value': '14:15'
              },
              {
                'value': '14:30'
              },
              {
                'value': '14:45'
              },
              {
                'value': '15:00'
              },
              {
                'value': '15:15'
              },
              {
                'value': '15:30'
              },
              {
                'value': '15:45'
              },
              {
                'value': '16:00'
              },
              {
                'value': '16:15'
              },
              {
                'value': '16:30'
              },
              {
                'value': '16:45'
              },
              {
                'value': '17:00'
              }
            ],
            [
              {
                'value': '10:00'
              },
              {
                'value': '10:15'
              },
              {
                'value': '10:30'
              },
              {
                'value': '10:45'
              },
              {
                'value': '11:00'
              },
              {
                'value': '11:15'
              },
              {
                'value': '11:30'
              },
              {
                'value': '11:45'
              },
              {
                'value': '12:00'
              },
              {
                'value': '12:15'
              },
              {
                'value': '12:30'
              },
              {
                'value': '12:45'
              },
              {
                'value': '13:00'
              }
            ]
          ],
          'disabled': []
        }
      }
    },

    computed: {
      ...mapState(['currentCountry', 'currentLang']),
      classes () {
        return [
          'datepicker',
          {
            'datepicker_active': this.isDropdownVisible,
            'datepicker_error': this.error
          }
        ]
      },
      datepickerOptions () {
        return {
          'monday-first': true,
          'full-month-name': true,
          'maximum-view': 'day',
          'use-utc': true,
          'inline': true,
          'language': this.datapickerLang,
          'format': this.formatDate(),
          'disabledDates': {
            to: new Date(new Date().setDate(new Date().getDate() + this.requestServiceIn)),
            days: this.disabledWeekDays,
            dates: [...this.datesWithNoAvailableTime, new Date()]
          }
        }
      },
      dropdownInsideTransitionName () {
        return this.isPickingTime
          ? 'slide-to-left'
          : 'slide-to-right'
      },
      dateTime () {
        // resulting timestamp (emiting value from component)
        const date = cloneDeep(this.date)
        const hours = Number(this.time.split(':')[0])
        const minutues = Number(this.time.split(':')[1])
        date.setHours(hours, minutues, 0, 0)
        return date.getTime()
      },
      disabledWeekDays () {
        // format to US day style
        // from 0 = Monday, 6 = Sunday
        // to 0 = Sunday, 6 = Saturday
        return this.workPeriod.disabled.map(dayIndex => {
          return dayIndex === 6
            ? 0
            : dayIndex + 1
        })
      }
    },

    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      },
      globalTime: {
        handler (globalTime) {
          if (!globalTime.length) {
            this.date = null
            this.time = ''
            this.datesWithNoAvailableTime = []
          }
          // this.error = time
        }
      }
    },

    created () {
      if (this.currentLang === 'ro') {
        this.datapickerLang = datapickerRo
        this.timepickerLang = ro
      } else if (this.currentLang === 'ru') {
        this.datapickerLang = datapickerRu
        this.timepickerLang = ru
      } else if (this.currentLang === 'uk') {
        this.datapickerLang = datapickerUk
        this.timepickerLang = uk
      } else if (this.currentLang === 'en') {
        this.datapickerLang = datapickerEn
        this.timepickerLang = enUS
      } else {
        if (this.currentCountry === 'md') {
          this.datapickerLang = datapickerRo
          this.timepickerLang = ro
        } else if (this.currentCountry === 'ru') {
          this.datapickerLang = datapickerRu
          this.timepickerLang = ru
        }
      }
    },

    methods: {
      initDatePicker () {
        // select first available date and time
        this.onDateChange(this.getFirstAvailableDate())
      },
      getFirstAvailableDate () {
        const today = new Date()
        const tomorrow = new Date()
        tomorrow.setDate(today.getDate() + 1)

        let availableDate = tomorrow

        while (!this.getFirstAvailableTime(availableDate)) {
          const thisDay = cloneDeep(availableDate)
          const nextDay = cloneDeep(thisDay)
          nextDay.setDate(thisDay.getDate() + 1)

          // disable day on calendar if it has no available time
          this.datesWithNoAvailableTime = [...this.datesWithNoAvailableTime, cloneDeep(thisDay)]

          availableDate = cloneDeep(nextDay)
        }

        return availableDate
      },
      getFirstAvailableTime (date) {
        const availableTime = this.getAvailableTimes(date).find(time => {
          return !('disabled' in time) || !time.disabled
        })

        return get(availableTime, 'value')
      },
      getAvailableTimes (date) {
        const selectedWeekDayIndex = getDay(date) === 0
          ? 6
          : getDay(date) - 1

        const isToday = () => {
          return date.getFullYear() === new Date().getFullYear() &&
            date.getMonth() === new Date().getMonth() &&
            date.getDate() === new Date().getDate()
        }

        if (isToday()) {
          // disable already passed times
          return this.workPeriod.enabled[selectedWeekDayIndex]
            ? this.workPeriod.enabled[selectedWeekDayIndex]
              .map(time => {
                const timeToCompare = new Date()
                const hours = Number(time.value.split(':')[0])
                const minutues = Number(time.value.split(':')[1])
                timeToCompare.setHours(hours, minutues, 0, 0)

                const isTimePass = differenceInMinutes(timeToCompare, new Date()) < 0

                return isTimePass
                  ? { ...time, disabled: true }
                  : time
              })
            : []
        }

        return this.workPeriod.enabled[selectedWeekDayIndex] || []
      },

      formatTime (date) {
        return format(date, 'HH:mm', { locale: this.timepickerLang })
      },
      formatDate (date) {
        if (!date) return ''
        return format(date, 'd MMMM yyyy', { locale: this.timepickerLang })
      },

      onDateChange (date) {
        this.date = date
        this.changeTime(this.time + ', ' + this.formatDate(date))
        this.$emit('input', this.dateTime)
        this.onTimeChange(this.getFirstAvailableTime(date), false)
        this.isPickingTime = true
      },
      onTimeChange (time, check = true) {
        this.time = time
        this.changeTime(time + ', ' + this.formatDate(this.date))
        this.$emit('input', this.dateTime)
        if (check) {
          setTimeout(() => {
            this.hideDropdown()
          }, 0)
        }
      },

      onPickTime () {
        this.isPickingTime = true
      },
      isTimeSelected (time) {
        return this.time === time.value
      },
      selectTime (time) {
        if (time.disabled) return
        this.onTimeChange(time.value)
      },

      toggleDropdownVisibility () {
        this.error = false
        this.isDropdownVisible
          ? this.hideDropdown()
          : this.showDropdown()
      },
      showDropdown () {
        this.isPickingTime = false
        this.isDropdownVisible = true
      },
      hideDropdown () {
        this.isDropdownVisible = false
        this.isPickingTime = false
      }
    }
  }
</script>

<style lang="scss">
  $padding-for-error: 20px;

  .datepicker {
    position: relative;
    display: block;
    align-self: flex-start;
    min-width: 290px;
    // max-width: 335px;
    padding-bottom: 0;
    cursor: pointer;

    @include mobile {
      max-width: 100%;
    }

    &.disabled {
      pointer-events: none;
      opacity: 0.6;

      .datepicker__field-wrapper {
        pointer-events: none;
      }

      .datepicker__arrow {
        opacity: 0;
      }
    }

    &__label {
      position: absolute;
      top: 19px;
      left: 20px;
      z-index: 1;
      display: inline-block;
      padding-bottom: 1em;
      font-family: NobelWGL-Book;
      font-weight: 400;
      letter-spacing: 1px;
      font-size: 16px;
      color: $c-gray-new;
      pointer-events: none;
      user-select: none;
      transition: all 0.2s;
      width: calc(100% - 75px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &-top {
        position: absolute;
        top: 6px;
        left: 20px;
        z-index: 1;
        font-size: 10px;
        line-height: 20px;
        color: $c-gray;
      }

      &-required {
        color: $c-error;
      }
    }

    &__field {
      position: relative;
      display: block;
      width: 100%;
      min-height: 56px;
      padding: 0 20px;
      padding-top: 28px;
      font-size: 16px;
      line-height: 1;
      background-color: $c-white;
      border: 1px solid $c-gray-light;
      outline: none;
      caret-color: $c-error;
      transition: 0.3s;
      font-family: NobelWGL-Book;
      font-weight: 400;
      letter-spacing: 1px;
      border-radius: 0;

      &:focus {
        background-color: $gray;
      }

      @include hover {
        background-color: $gray;
      }
    }

    &__arrow {
      position: absolute;
      right: 4%;
      bottom: 30%;
      transition: 0.3s;
    }

    &__date {
      padding-left: 5px;
      color: $c-gray-dark;
    }

    &__dropdown {
      position: absolute;
      top: calc(100% + 5px);
      right: 0;
      z-index: 9999;
      width: 100%;
      max-width: 275px;
      // max-width: 335px;
      padding: 15px 10px 0;
      cursor: default;
      user-select: none;
      background-color: $c-white;
      box-shadow: 2px 2px 5px rgba($c-black, 0.1);

      @include mobile {
        right: 0;
        padding: 5px 0;
      }

      .vdp-datepicker__calendar {
        width: 100%;
        padding-left: 4px;
        margin: 0 auto;
        background: transparent;
        border: none;
        padding-bottom: 8px;

        @include mobile {
          padding-left: 27px;
          transform: translateX(-13px);
        }

        @include mobileXs {
          padding-left: 0;
          transform: translateX(1px);
        }

        header {
          display: flex;
          justify-content: space-between;
          padding: 0 15%;
          // border-bottom: 1px solid #c7cfd7;

          .day__month_btn.up {
            transition: color 0.3s;

            &:hover {
              color: $c-black-mind;
              background: transparent;
            }
          }
        }

        .prev,
        .next {
          overflow: hidden;
          background: url('../../assets/img/icons/chevron.svg') no-repeat center;
          background-size: 15px;
          opacity: 0.7;
          transition: background 0.3s, opacity 0.3s;
          transform: rotate(-180deg);

          &::after {
            display: none;
          }

          &:hover:not(.disabled) {
            background: url('../../assets/img/icons/chevron-red.svg') no-repeat center;
            background-size: 15px;
            opacity: 1;
          }

          &.disabled {
            opacity: 0.2;
          }
        }

        .prev {
          transform: rotate(0deg);
        }

        .cell {
          font-size: 14px;
          font-family: NobelWGL-Book;
          font-weight: 400;
          line-height: 40px;
          border: none !important;
          transition: all 0.3s;

          &.day-header {
            border-bottom: 1px solid #c7cfd7 !important;
          }

          &.month {
            &:hover {
              color: $c-error;
              background: transparent;
            }
          }

          &.selected {
            color: $c-white !important;
            background: $c-black-mind;
          }

          &.weekend {
            &:hover {
              color: $c-black;
            }
          }

          &:hover {
            color: $c-black;
            background: $c-gray-light !important;
          }

          &.day {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            height: unset;
            padding: 0;
            font-size: 14px;
            font-family: NobelWGL-Book;
            font-weight: 400;
            letter-spacing: 1px;
            text-align: center;
            vertical-align: middle;
            color: $c-black-mind;
            border-radius: 50%;
            aspect-ratio: 1;
            line-height: normal;

            @include mobileXs {
              margin: 1px 4.6px 0;
            }
          }

          &.day-header,
          &.blank {
            color: $c-gray-dark;

            &:hover {
              color: $c-gray-dark;
              cursor: default;
              background: transparent;
            }
          }

          &.disabled {
            color: $c-gray-medium;
            pointer-events: none;
          }
        }
      }

      &-button {
        &-container {
          display: flex;
          justify-content: center;
          margin: 20px 0;
        }

        background-color: $c-white;
        transition: all 0.4s;

        &:hover {
          background-color: $c-white;
          // box-shadow: 0 2px 10px 0 $c-gray-medium;
        }
      }

      &-time {
        padding-right: 10px;
        padding-left: 10px;
        font-family: NobelWGL-Book;
        font-weight: 400;
        letter-spacing: 1px;
        font-size: 16px;

        &-title {
          padding-bottom: 17px;
          margin: 10px 0 9px;
          text-align: center;
          border-bottom: 1px solid $c-gray-light;
        }
      }

      &-times {
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
      }

      &-time-item {
        flex: 0 1 20%;
        padding: 8px;
        // margin-bottom: 25px;
        font-size: 14px;
        color: $c-black-mind;
        text-align: center;
        cursor: pointer;
        // transition: color 0.3s;

        &:hover {
          color: $c-black;
          background: $gray;
          border-radius: 24px;
        }

        &_disabled {
          color: $c-gray-medium;
          pointer-events: none;
        }

        &_selected {
          color: $c-white;
          background: $c-black-mind;
          border-radius: 24px;
        }
      }

      &-back-to-calendar-button {
        display: flex;
        align-items: center;
        margin-right: 5px;
        cursor: pointer;

        &-arrow {
          width: 16px;
          height: 16px;
          margin-right: 10px;
          transition: 0.3s;
        }

        &-text {
          font-family: 'NobelWGL-Bold', sans-serif;
          font-size: 12px;
          font-weight: 700;
          line-height: 20px;
          text-transform: uppercase;
          transition: color 0.3s;

          svg {
            position: relative;
            top: -3px;
          }
        }

        &:hover {
          .datepicker__dropdown-back-to-calendar-button {
            &-text {
              color: $c-black-mind;
            }

            &-arrow {
              stroke: $c-black-mind;
            }
          }
        }
      }
    }

    &__error-msg {
      position: absolute;
      bottom: 14px;
      left: 0;
      height: 0;
      padding-right: 20px;
      font-size: 12px;
      color: $c-error;

      &-icon {
        position: absolute;
        top: 59px;
        right: 0;
        path{
          fill: $c-error;
        }
      }
    }

    &_error {
      padding-bottom: $padding-for-error;

      .datepicker {
        &__field {
          border-color: $c-error;
        }
      }
    }

    &_active {
      .datepicker {
        &__field {
          background-color: $gray;
        }

      }
    }
  }
  .vdp-datepicker__calendar header span {
    font-family: NobelWGL-Book;
    font-weight: 400;
  }
</style>
